export interface NotificationMessage {
  title: string;
  body: string;
}

export interface NotificationRequest {
  topics: string[];
  message: NotificationMessage;
}

export function newNotificationMessage(): NotificationMessage {
  return {
    title: null,
    body: null,
  };
}

export function newNotificationRequest(): NotificationRequest {
  return {
    topics: [],
    message: newNotificationMessage(),
  };
}

export interface LocationPicker {
  id: string;
  value: string;
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/notifications/notification.interfaces.ts